<template>
  <!-- Note: don't reformat the line below in order not to add extra spaces -->
  <span class="VAT-tip" v-if="showVATTip && excludingText"><span class="dot">,</span> {{ excludingText }}</span>
</template>

<script>
import { taxExclusions } from './constant';

export const taxExclusionsList = taxExclusions;

export default {
  name: 'PRICE_VAT_TIP',
  props: {
    showVATTip: {
      type: Boolean,
      default: false
    },
    currentCountry: {
      type: String,
      default: ''
    }
  },
  computed: {
    excludingText() {
      if (!this.showVATTip) return '';
      const text = taxExclusions.find((c) => c.id === this.currentCountry)?.text;
      return text || '';
    },
  },
};
</script>
<style lang="scss">
.wbn-single-price-outer-containe .price-info .rate,
.ze-price-outer-container .rate,
.addon-modal__container-body__price .price-main__info .rate {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
  padding-left: 5px;

  .dot {
    display: none;
  }
}

.detail-dialog__price .price__unit {
  display: inline-flex;
  flex-direction: column;
  align-self: center !important;
  font-size: 12px !important;
  line-height: 14px !important;

  .dot {
    display: none;
  }
}

.opc-cart__total__text__sub {
  .dot {
    display: none;
  }
}

.VAT-tip {
	text-transform: none;
}
</style>
